import React from 'react';

// eslint-disable-next-line react/prop-types
function Common({ imageSrc, heading, paragraph }) {
  return (
    <div className="relative bg-white rounded-[20px] shadow-lg p-[40px] flex flex-col items-start justify-center overflow-hidden flex-1">
      {/* Solid color base */}
      <div className="absolute inset-y-0 left-0 w-[10px] bg-[#114036]" />

      {/* Gradient overlay */}
      <div className="absolute inset-y-0 left-0 w-[10px] bg-gradient-to-b from-[#FFFFFF] via-[#C2FFA5] via-[#D4FFC1] to-[#FFFFFF] opacity-70" />

      {/* Card Content */}
      <div className="flex items-center">
        {imageSrc && (
          <img src={imageSrc} alt="Icon" className="w-11 h-11 mr-4" />
        )}
        <h2 className="card-content-heading">{heading}</h2>
      </div>
      {/* Added margin-top for spacing between heading and paragraph */}
      {Array.isArray(paragraph) ? (
        <ul className="card-content mt-[20px] list-disc pl-6 space-y-1">
          {paragraph.map((line, i) => (
            <li key={i}>{line.replace(/^- /, '')}</li>
          ))}
        </ul>
      ) : (
        <p className="card-content mt-[20px]">{paragraph}</p>
      )}
    </div>
  );
}

export default Common;
